import * as Types from '../../../../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAsyncQueryDownloadUrlVariables = Types.Exact<{
  input: Types.GetAsyncQueryDownloadUrlInput;
}>;

export type GetAsyncQueryDownloadUrl = {
  getAsyncQueryDownloadUrl: Pick<Types.GetAsyncQueryDownloadUrlOutput, 'url'> & {
    error?: Types.Maybe<Pick<Types.Error, 'message'>>;
  };
};

export type StartAsyncDownloadOfAllQueryResultsVariables = Types.Exact<{
  input: Types.StartAsyncDownloadOfAllQueryResultsInput;
}>;

export type StartAsyncDownloadOfAllQueryResults = {
  startAsyncDownloadOfAllQueryResults: { error?: Types.Maybe<Pick<Types.Error, 'message'>> };
};

export const GetAsyncQueryDownloadUrlDocument = gql`
  query GetAsyncQueryDownloadUrl($input: GetAsyncQueryDownloadUrlInput!) {
    getAsyncQueryDownloadUrl(input: $input) {
      url
      error {
        message
      }
    }
  }
`;

/**
 * __useGetAsyncQueryDownloadUrl__
 *
 * To run a query within a React component, call `useGetAsyncQueryDownloadUrl` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncQueryDownloadUrl` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncQueryDownloadUrl({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAsyncQueryDownloadUrl(
  baseOptions: Apollo.QueryHookOptions<GetAsyncQueryDownloadUrl, GetAsyncQueryDownloadUrlVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAsyncQueryDownloadUrl, GetAsyncQueryDownloadUrlVariables>(
    GetAsyncQueryDownloadUrlDocument,
    options,
  );
}
export function useGetAsyncQueryDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAsyncQueryDownloadUrl,
    GetAsyncQueryDownloadUrlVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAsyncQueryDownloadUrl, GetAsyncQueryDownloadUrlVariables>(
    GetAsyncQueryDownloadUrlDocument,
    options,
  );
}
export function useGetAsyncQueryDownloadUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAsyncQueryDownloadUrl,
    GetAsyncQueryDownloadUrlVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAsyncQueryDownloadUrl, GetAsyncQueryDownloadUrlVariables>(
    GetAsyncQueryDownloadUrlDocument,
    options,
  );
}
export type GetAsyncQueryDownloadUrlHookResult = ReturnType<typeof useGetAsyncQueryDownloadUrl>;
export type GetAsyncQueryDownloadUrlLazyQueryHookResult = ReturnType<
  typeof useGetAsyncQueryDownloadUrlLazyQuery
>;
export type GetAsyncQueryDownloadUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetAsyncQueryDownloadUrlSuspenseQuery
>;
export type GetAsyncQueryDownloadUrlQueryResult = Apollo.QueryResult<
  GetAsyncQueryDownloadUrl,
  GetAsyncQueryDownloadUrlVariables
>;
export const StartAsyncDownloadOfAllQueryResultsDocument = gql`
  mutation StartAsyncDownloadOfAllQueryResults($input: StartAsyncDownloadOfAllQueryResultsInput!) {
    startAsyncDownloadOfAllQueryResults(input: $input) {
      error {
        message
      }
    }
  }
`;
export type StartAsyncDownloadOfAllQueryResultsMutationFn = Apollo.MutationFunction<
  StartAsyncDownloadOfAllQueryResults,
  StartAsyncDownloadOfAllQueryResultsVariables
>;

/**
 * __useStartAsyncDownloadOfAllQueryResults__
 *
 * To run a mutation, you first call `useStartAsyncDownloadOfAllQueryResults` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAsyncDownloadOfAllQueryResults` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAsyncDownloadOfAllQueryResults, { data, loading, error }] = useStartAsyncDownloadOfAllQueryResults({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAsyncDownloadOfAllQueryResults(
  baseOptions?: Apollo.MutationHookOptions<
    StartAsyncDownloadOfAllQueryResults,
    StartAsyncDownloadOfAllQueryResultsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartAsyncDownloadOfAllQueryResults,
    StartAsyncDownloadOfAllQueryResultsVariables
  >(StartAsyncDownloadOfAllQueryResultsDocument, options);
}
export type StartAsyncDownloadOfAllQueryResultsHookResult = ReturnType<
  typeof useStartAsyncDownloadOfAllQueryResults
>;
export type StartAsyncDownloadOfAllQueryResultsMutationResult =
  Apollo.MutationResult<StartAsyncDownloadOfAllQueryResults>;
export type StartAsyncDownloadOfAllQueryResultsMutationOptions = Apollo.BaseMutationOptions<
  StartAsyncDownloadOfAllQueryResults,
  StartAsyncDownloadOfAllQueryResultsVariables
>;
export function mockGetAsyncQueryDownloadUrl({
  data,
  variables,
  errors,
}: {
  data: GetAsyncQueryDownloadUrl;
  variables?: GetAsyncQueryDownloadUrlVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetAsyncQueryDownloadUrlDocument, variables },
    result: { data, errors },
  };
}
export function mockStartAsyncDownloadOfAllQueryResults({
  data,
  variables,
  errors,
}: {
  data: StartAsyncDownloadOfAllQueryResults;
  variables?: StartAsyncDownloadOfAllQueryResultsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: StartAsyncDownloadOfAllQueryResultsDocument, variables },
    result: { data, errors },
  };
}
